module.exports = __webpack_public_path__ + "media/images/homes/MobileResponsiveSite-1dbc147a2282e39fdcbc377f9bf20752.png";